"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeStoredValue = exports.setStoredValue = exports.getStoredValue = exports.enableTempStorage = void 0;
const _tempStorage = {
    enabled: false,
};
function enableTempStorage() {
    _tempStorage.enabled = true;
}
exports.enableTempStorage = enableTempStorage;
function getStoredValue(key) {
    if (_tempStorage.enabled) {
        return _tempStorage[key];
    }
    return localStorage.getItem(key);
}
exports.getStoredValue = getStoredValue;
function setStoredValue(key, value) {
    if (_tempStorage.enabled) {
        return (_tempStorage[key] = value);
    }
    return localStorage.setItem(key, value);
}
exports.setStoredValue = setStoredValue;
function removeStoredValue(key) {
    if (_tempStorage.enabled) {
        return delete _tempStorage[key];
    }
    return localStorage.removeItem(key);
}
exports.removeStoredValue = removeStoredValue;
